export const environment = {
  production: true,
  api_url: 'https://jpos2.com:1500',
  url_print: 'https://jpos2.com',
  socketurl: 'ws://jpos2.com:1500',
  printBill: 'https://jpos2.com/jpos_bill_new',
  printBillOld: 'https://jpos2.com/bill',
  searchAPI: 'https://jpos2.com:1520'
};
